import * as _ from "lodash"
import { IHaveTags } from '../PA.Core/PA.Core.IF.Aspects'
import { WB_TagRow } from '../PA.Core/PAdbSchemaRows'
import { BehaviorSubject } from 'rxjs'
import { IDateRange } from '../PA.Core/PA.Core.IF.Basic'


export class TaggablePolicyProxy implements IHaveTags {

    private _taggable: IHaveTags
    private _dctTagCacheLoaded: boolean
    private _dctTagById: {[wbTagId: number]: WB_TagRow}

    constructor(taggable: IHaveTags){
        this._dctTagCacheLoaded = false
        this._dctTagById = {}
        this._taggable = taggable
    }

    get  AllTags(): WB_TagRow[] { return this._taggable.AllTags }
    get  OnIHaveTagsLoaded(): Promise<IHaveTags> { return this._taggable.OnIHaveTagsLoaded }
    get Tags(): WB_TagRow[] { return this._taggable.Tags }
    get TagsChanged(): BehaviorSubject<IHaveTags> { return this._taggable.TagsChanged }
    get TagsReadOnly(): boolean { return this._taggable.TagsReadOnly }
    get UsageId(): string { return this._taggable.UsageId }
    get bIHaveTagsLoaded(): boolean { return this._taggable.bIHaveTagsLoaded }
    get bTagHasDateRange(): boolean { return this._taggable.bTagHasDateRange }
    get getDateRange(): (TagId: number) => IDateRange { return this._taggable.getDateRange }
    get setDateRange(): (TagId: number, dRange: IDateRange) => void { return this._taggable.setDateRange }

    hasTag(TagId: number): boolean { return this._taggable.hasTag(TagId) }

    private getTagById(wbTagId: number): WB_TagRow {
        if(this._dctTagCacheLoaded)
            return this._dctTagById[wbTagId]
        if(this._taggable.bIHaveTagsLoaded){
            this._dctTagCacheLoaded = true
            this._dctTagById = _.keyBy(this._taggable.AllTags, (t) => t.cif.WB_TAG_ID)
        }
        return this._dctTagById[wbTagId]
    }

    private getTagParent(tag: WB_TagRow, sType: string, iLimit?: number): WB_TagRow {
        if (_.isEmpty(tag))
            return undefined

        if(!_.isNumber(iLimit))
            iLimit = 5

        if(!(iLimit > 0))
            return undefined

        iLimit--

        for (let aRel of tag.WB_TagRelationshipRows_Parent) {
            if (!aRel.isActive)
                continue

            if (_.isEmpty(aRel.WB_TagRowParent))
                continue

            if (aRel.WB_TagRowParent.cif.WB_TAG_ID in this._dctTagById) {
                if (aRel.WB_TagRowParent.cif.TAG_TYPE == sType)
                    return aRel.WB_TagRowParent
            }
            return this.getTagParent(aRel.WB_TagRowParent, sType, iLimit)
        }

        return undefined
    }

    private getChildren(tag: WB_TagRow, sType: string): WB_TagRow[] {
        let dct: {[wbTagId: number]: WB_TagRow} = {}

        this.addChildren(tag, sType, dct, 5)

        return _.values(dct)
    }

    private addChildren(tag: WB_TagRow, sType: string, dctChildren: {[wbTagId: number]: WB_TagRow}, iLimit: number): void {
        if(_.isEmpty(tag))
            return
        if(!(iLimit > 0))
            return
        iLimit--

        _.forEach(tag.WB_TagRelationshipRows_Children, (aRel) => {
            if(!aRel.isActive)
                return
            if(_.isEmpty(aRel.WB_TagRowChild))
                return
            if(aRel.WB_TagRowParent.cif.WB_TAG_ID in dctChildren)
                return
            if(aRel.WB_TagRowChild.cif.TAG_TYPE == sType){
                dctChildren[aRel.WB_TagRowChild.cif.WB_TAG_ID] = aRel.WB_TagRowChild
            } else {
                // recurse down
                this.addChildren(aRel.WB_TagRowChild, sType, dctChildren, iLimit)
            }
        })
    }

    async addTag(TagId: number): Promise<void> {
        // See if the tag group has a policy
        let tag = this.getTagById(TagId)
        let tagGrp = this.getTagParent(tag, "TagGroup")
        // If no Tag Group found, use default processing
        if(!tagGrp) {
            await this._taggable.addTag(TagId)
            return
        }

        switch(tagGrp.cif.TAG_SELECTION_POLICY) {
            case 'ZeroOrOne':
            case 'One':
                // Remove any already selected Tags in Group
                let children = this.getChildren(tagGrp, "Tag")
                children = _.filter(children, (c) => c.cif.WB_TAG_ID != TagId)
                for(let c of children) {
                    if(this.hasTag(c.cif.WB_TAG_ID))
                      this._taggable.removeTag(c.cif.WB_TAG_ID)
                }
                await this._taggable.addTag(TagId)
                break;
            case 'Many':
            case "ZeroOrMany":
            case "Zero or One":
            case 'OneOrMany':
            case 'None':
            default:
                // pass through
                await this._taggable.addTag(TagId)
                return
        }

    }

    removeTag(TagId: number): void {
        let tag = this.getTagById(TagId)
        let tagGrp = this.getTagParent(tag, "TagGroup")
        // If no Tag Group found, use default processing
        if(!tagGrp) {
            this._taggable.removeTag(TagId)
            return
        }

        switch(tagGrp.cif.TAG_SELECTION_POLICY) {
            case 'One':
            case 'OneOrMany':
                // Prevent the last one from being removed
                let children = this.getChildren(tagGrp, 'Tag')
                children = _.filter(children, (c) => c.cif.WB_TAG_ID != TagId)
                let tagCount = 0
                for (let c of children) {
                    if (this.hasTag(c.cif.WB_TAG_ID))
                        tagCount++
                }

                if (tagCount > 0)
                    this._taggable.removeTag(TagId)

                break
            case 'ZeroOrOne':
            case 'Many':
            case "ZeroOrMany":
            case "Zero or One":
            case 'None':
            default:
                // pass through
                this._taggable.removeTag(TagId)
                return
        }

    }




}